var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../../config/config';
import { mapProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchBoost } from './api';
export class BoostSearchProvider {
    constructor() {
        this.products = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            var _a, _b, _c;
            const { page = 1, pageSize = AppConfig.page.defaultSize, sort = 'manual', filters, merchandising } = options;
            try {
                // Format price filter if it exists
                const formattedFilters = filters ? Object.assign({}, filters) : undefined;
                if (formattedFilters === null || formattedFilters === void 0 ? void 0 : formattedFilters.pf_p_price) {
                    // Ensure price filter is in the correct format (min:max)
                    formattedFilters.pf_p_price = formattedFilters.pf_p_price.map(value => {
                        // If value already contains ':', return as is
                        if (value.includes(':'))
                            return value;
                        // Otherwise, replace ',' with ':'
                        return value.replace(',', ':');
                    });
                }
                // Convert MerchandisingConfig to Boost's expected format
                const boostMerchandising = merchandising ? {
                    applyRules: merchandising.enableRules,
                    boostProducts: (_a = merchandising.boosts) === null || _a === void 0 ? void 0 : _a.map(b => b.productId),
                    hideProducts: ((_b = merchandising.merchandisingFilters) === null || _b === void 0 ? void 0 : _b.includes('hide:'))
                        ? merchandising.merchandisingFilters.split('hide:')[1].split(',')
                        : undefined,
                    pinProducts: (_c = merchandising.pins) === null || _c === void 0 ? void 0 : _c.map(p => ({
                        productId: p.productId,
                        position: typeof p.position === 'number' ? p.position : p.position.start
                    }))
                } : undefined;
                const data = yield fetchBoost({
                    q: query,
                    page,
                    pageSize,
                    sort,
                    filters: formattedFilters,
                    merchandising: boostMerchandising,
                    fuzzy: true, // Enable typo tolerance by default
                });
                this.products = mapProducts(data.products);
                this.filters = mapFilters(data.filter, formattedFilters);
                this.meta = mapMeta(data, page, pageSize);
                this.sortOptions = mapSorts();
            }
            catch (error) {
                throw new Error('Failed to load mock data');
            }
        });
    }
    getProducts() {
        return this.products;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
}
